import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "../common/Toast/toast";
import { useAuth } from "../../../context/AuthContext";
import CrmReportPage from "./CrmReportPage.jsx";
import "../Trainer/TrainerDashboard.css";
import "../common/lms-pages.css";

/* A CRM report page: student or batch performance, each its own entry
   under CRM in the sidebar (Menu.jsx) and its own route (index.jsx).
   The `crm-reports` module grant (view) opens both -- the same grant its
   API routes check (crmreport.routes.js). */

const REPORTS = {
  students: {
    title: "Student Report",
    sub: "How regularly students attend their batches. Open a band to see who is in it.",
    note: "One row per student per batch: sessions attended out of sessions held in the period.",
  },
  batches: {
    title: "Batch Report",
    sub: "Which batches have the best attendance and feedback.",
    note: "Score: attendance 60%, feedback 40% (feedback counts from 5 responses).",
  },
};

const CrmReports = ({ kind = "students" }) => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const allowed = hasPermission("crm-reports", "view", "lms");
  const warned = useRef(false);
  const report = REPORTS[kind] || REPORTS.students;

  useEffect(() => {
    if (!allowed && !warned.current) {
      warned.current = true;
      toast.error("You do not have permission to view this report.");
      navigate("/");
    }
  }, [allowed, navigate]);

  if (!allowed) return null;

  return (
    <div className="pg lp">
      <header className="pg-head">
        <div className="pg-head-main">
          <h4 className="pg-title">{report.title}</h4>
          <p className="pg-sub">{report.sub}</p>
        </div>
      </header>

      {/* key: each report loads its own figures and keeps no state from another. */}
      <CrmReportPage key={kind} kind={kind} note={report.note} />
    </div>
  );
};

export default CrmReports;
